import {
  MediaInfo,
  MediaItem,
  MediaLinkedType,
  UpsertSegmnetEntry,
  UpsertSegmnetsResultEntry,
} from "./media";
import { Subject, Observable } from "rxjs";
import moment from "moment";
import { MediaQCWorkflowObjective } from "./qc-workflow";

export abstract class MediaRepository {
  mediaUpdated: Subject<MediaInfo>;
  mediaAssociatedFilesUpdated: Observable<void>;
  getMedia: (
    searchQuery: string,
    offset: number,
    orderByMedia: number,
    sortByMedia: string,
    startDateCreatedMedia: moment.Moment,
    endDateCreatedMedia: moment.Moment,
    startDateLicense: moment.Moment,
    endDateLicense: moment.Moment,
    statusChosen: string,
    countries: number[],
    tagIds: number[],
    assetTypeIds: number[],
    languages: string[],
  ) => Promise<MediaItem[]>;

  getMediaInfo: (id: number) => Promise<MediaInfo>;
  getMediaIdByTenantUniqueId: (tenantUniqueId: string) => Promise<number>;

  createContract: () => Promise<number>;

  update: (mediaInfo: MediaInfo) => Promise<void>;

  deleteMedia: (id: number) => Promise<void>;

  contentUpload: (
    url: string,
    filename: string,
    connectionId: string,
    parentMediaId?: number,
    mediaLinkedType?: MediaLinkedType,
    contractId?: number,
    customProps?: any,
  ) => Promise<{ mediaId: number; mediaUid: string }>;

  packshotUpload: (
    url: string,
    connectionId: string,
    mediaId: number,
  ) => Promise<void>;

  LogoUploadAnalyze: (
    channelId: number,
    url: string,
    isVideo: boolean,
  ) => Promise<any>;

  isTenantMediaIdUnique: (
    tenantMediaId: string,
    ignoreMediaId?: number,
  ) => Promise<number>;

  uploadSubtitle: (
    file: File,
    mediaId,
  ) => Promise<{
    id: number;
    language: string;
    offset: number;
    fps: number;
    playbackSpeed: number;
  }>;

  uploadClosedCaption: (
    objectKey: string,
    fileName: string,
    mediaId,
  ) => Promise<{
    id: number;
    language: string;
    offset: number;
    fps: number;
    playbackSpeed: number;
    flavor?: string;
  }>;

  removeSubtitle: (id: number) => Promise<void>;

  getMediaPreviewUrl: (mediaId: number) => Promise<string>;

  /** Presigned preview/proxy URL via GET UserMedia/{id}/PreviewFile (system TTL). */
  getMediaPreviewFileUrl: (mediaId: number) => Promise<string>;

  getMediaTranscodedUrl: (mediaId: number) => Promise<string>;

  downloadOriginalFile: (mediaId: number) => Promise<any>;

  downloadTranscodedFile: (mediaId: number) => Promise<any>;

  downloadPreview: (mediaId: number) => Promise<any>;

  getTenantMediasLanguages: () => Promise<[{ code: string; name: string }]>;

  upsertSegments: (
    segments: Array<UpsertSegmnetEntry>,
  ) => Promise<Array<UpsertSegmnetsResultEntry>>;
  addQCWorkflowObjective: (
    mediaId: number,
  ) => Promise<Array<MediaQCWorkflowObjective>>;
}
